import { Box, Stack, Typography } from '@mui/material';
import { ProfileGraph } from '../apiClients/ProfileClient';

interface ScoreCardProps {
    profileGraph: ProfileGraph;
}

const ScoreCard: React.FC<ScoreCardProps> = ({ profileGraph }) => {
    return (
        <Stack
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            flexWrap="wrap"
            aria-label="Template scores"
            sx={{ gap: 1.5, textAlign: 'center' }}>
            {profileGraph?.ScoreCard.ProficiencyGroupScores.map((pgs: any) => // Replace 'any' with the actual type of pgs
                <Box key={pgs.ProficiencyGroup} sx={{ minWidth: 76 }}>
                    <Typography variant="caption" component="div" fontWeight={700}>{pgs.ProficiencyGroup}</Typography>
                    <Typography variant="body2">{pgs.Score}</Typography>
                </Box>
            )}
            <Box sx={{ minWidth: 76 }}>
                <Typography variant="caption" component="div" fontWeight={700}>Overall Score</Typography>
                <Typography variant="body2">{profileGraph?.ScoreCard.OverallScore ?? 0.0}</Typography>
            </Box>
        </Stack>
    );
};

export default ScoreCard;
